<p class="text-center">
    Vennligst logg brukeren for øyeblikket ........
</p>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>